import { render, staticRenderFns } from "./NewTemplateGroup.vue?vue&type=template&id=44d290dc&scoped=true&"
import script from "./NewTemplateGroup.vue?vue&type=script&lang=js&"
export * from "./NewTemplateGroup.vue?vue&type=script&lang=js&"
import style0 from "./NewTemplateGroup.vue?vue&type=style&index=0&id=44d290dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d290dc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDataTable,VDialog,VIcon,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d290dc')) {
      api.createRecord('44d290dc', component.options)
    } else {
      api.reload('44d290dc', component.options)
    }
    module.hot.accept("./NewTemplateGroup.vue?vue&type=template&id=44d290dc&scoped=true&", function () {
      api.rerender('44d290dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Template/modal/NewTemplateGroup.vue"
export default component.exports